import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "../../../services/redux/authSlice";
import tokenApi from "../../../services/apiServices/tokenApi";
import "./TokenLoginPage.css";
import { setLoading } from "../../../services/redux/loadingSlice";
import { useNavigate } from "react-router-dom";
import MessageModal from "../../../components/common/Modals/MessageModal/MessageModal";

const TokenLoginPage = () => {
    const [error, setError] = useState("");
    const [isMessageOpen, setIsMessageOpen] = useState(false);
    const [message, setMessage] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const openMessageModal = () => {
        setIsMessageOpen(true);
    };

    const closeMessageModal = () => {
        setIsMessageOpen(false);
        navigate("/"); // Redirect to home after closing the message modal
    };

    useEffect(() => {
        const loginWithToken = async () => {
            try {
                dispatch(setLoading(true));
                const urlParams = new URLSearchParams(window.location.search);
                const token = urlParams.get("token"); // Extract token from URL

                if (!token) {
                    setError("Token não encontrado na URL.");
                    return;
                }

                const payload = { guid: token };
                const response = await tokenApi.getToken(payload);

                if (response.code) {
                    setMessage(response.message);
                    openMessageModal();
                } else {
                    // Successful login
                    dispatch(
                        login({
                            access_token: response.access_token,
                            persontypecode: response.persontypecode,
                            name: response.name,
                            code: response.id,
                        })
                    );
                    navigate("/"); // Redirect to home page
                }
            } catch (err) {
                setError("Falha na autenticação. O token não é válido ou expirou.");
                console.error("Token login failed:", err);
            } finally {
                dispatch(setLoading(false));
            }
        };

        loginWithToken();
    }, [dispatch, navigate]);

    if (error) {
        return (
            <div className="token-login-page">
                <MessageModal
                    isOpen={true}
                    click={() => navigate("/")}
                    message={error}
                />
            </div>
        );
    }

    return (
        <div className="token-login-page">
            <MessageModal
                isOpen={isMessageOpen}
                click={closeMessageModal}
                message={message}
            />
            <p>Autenticando...</p>
        </div>
    );
};

export default TokenLoginPage;
